import React from "react";
import Restart from '../Images/Restart.png'
import RestartWhite from '../Images/Restart - Copy.png'
import './ReturnHome.scss'
const ReturnHome = (props) => {
  return (
      <div onClick={props.onClick} style={props.style} className="return-home"><img src={props.white? RestartWhite: Restart} alt="restart"/> <p>Return to Home</p></div>
  );
};

export default ReturnHome;
